/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React from 'react';
import axios from 'axios';
import { WarningMessage } from '../Utils.js';
import { LittleChoicesButton } from './ChoicesButton.jsx';


class ChoicesList extends React.Component {
  state = {
    choices: [],
    selectedChoice: null
  }

  componentDidMount() {
    axios.options(this.props.url)
      .then(res => {
        const choices = res.data.actions.POST[this.props.field].choices;
        this.setState({ choices });
      })
      .catch(error => {
        WarningMessage(error);
        this.setState({ choices: [] });
      });
  }

  handleChoiceClick = (choiceValue) => {
    const acceptValue = "." + choiceValue;
    let fileinput = document.getElementById('filedcd');
    if (fileinput) {
      fileinput.setAttribute("accept", acceptValue);
    }
    this.setState({ selectedChoice: choiceValue });
    this.props.onChoiceSelected(choiceValue);
  }

  render() {
    return (
      <div className="flex text-sm space-x-2">
        {this.state.choices.map(choice => { 
          return (
            <div key={"button-" + choice.value} className="flex space-x-4 text-sm space-y-1 items-center">
            <LittleChoicesButton label={choice.value} handle={ this.handleChoiceClick } selected={ this.state.selectedChoice } value={choice.value}/>
            </div>
          );
        })}
      </div>
    );
  }
}


export default ChoicesList